import React from "react";
import MainLayout from "../../../hoc/main";
import {Grid, TableData} from "../../../components";
import {connect} from "react-redux";
import {deleteActionGroupData, getActionGroupDatas,} from "../../../redux/modules/ActionGroup/action";

class ActionGroup extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            datas: [],
        };
    }

    componentDidMount() {
        this.props.getActionGroupDatas();
    }

    UNSAFE_componentWillReceiveProps(np) {
        this.setState({
            datas: np.actionGroup.datas,
        });
    }

    render() {
        // console.log(this.state.datas);
        const actionGroupColumn = [
            {
                name: "Group",
                path: "name",
                show: true,
            },
            {
                name: "Action",
                path: "action",
                show: true,
            },
        ];

        return (
            <div className="p-6 mt-20 xl:mt-0 ">
                <Grid>
                    <TableData
                        addData={true}
                        trashBin={true}
                        path={this.props.location.pathname}
                        title={"ActionGroup Data"}
                        data={this.props.actionGroup.datas}
                        columns={actionGroupColumn}
                        action={["update", "delete"]}
                        trash={true}
                        deleteAction={(id) => this.props.deleteActionGroupData(id)}
                    />
                </Grid>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    actionGroup: state.actionGroup,
});

const mapDispatchToProps = {
    getActionGroupDatas,
    deleteActionGroupData,
};

export default MainLayout(connect(mapStateToProps, mapDispatchToProps)(ActionGroup));
